import React from "react";
import InformationPanel from "components/InformationPanel/InformationPanel";

export const NoticesForAction: React.FC<{ actionNotices: string[] }> = ({ actionNotices }) => {
    if (actionNotices.length === 0) {
        return null;
    }
    return <InformationPanel message={"Potential issues were found"} notices={actionNotices} parsedHelpLinks={undefined} helpText={undefined} helpLink={undefined} scrollToPanel={false} />;
};
